import { render, staticRenderFns } from "./HandSquare.vue?vue&type=template&id=6f5af81f&scoped=true&"
import script from "./HandSquare.vue?vue&type=script&lang=js&"
export * from "./HandSquare.vue?vue&type=script&lang=js&"
import style0 from "./HandSquare.vue?vue&type=style&index=0&id=6f5af81f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5af81f",
  null
  
)

export default component.exports